import React from "react";

const AddWorkButton = ({ onAddWork }) => (
  <button onClick={onAddWork} className="open-panel-btn">Add Work</button>
);

export default AddWorkButton;
